export { default } from './define-stack-id'
